import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { RequireAuth } from "@/app/auth/guards"
import { useWorkspaces } from "@/shared/api/queries"
import type { WorkspaceId } from "@/shared/api/types"
import { LoadingBlock } from "@/widgets/LoadingBlock"
import { Alert } from "@/shared/ui/Alert"

/** Требует доступ к кабинету по списку с сервера (`GET /me/workspaces`). */
export const RequireWorkspace = ({
  id,
  children,
}: {
  id: WorkspaceId
  children: ReactNode
}) => {
  const { t } = useTranslation()
  const workspaces = useWorkspaces(true)

  return (
    <RequireAuth>
      {workspaces.isLoading ? <LoadingBlock variant="page" message={t("common.loading")} /> : null}
      {workspaces.isError ? (
        <div className="mx-auto max-w-2xl px-6 py-16">
          <Alert tone="error">{t("workspaces.loadFailed")}</Alert>
        </div>
      ) : null}
      {workspaces.isSuccess && !workspaces.data.items.some((item) => item.id === id) ? (
        <div className="mx-auto max-w-2xl px-6 py-16">
          <Alert tone="warning">{t("common.auth.forbidden")}</Alert>
        </div>
      ) : null}
      {workspaces.isSuccess && workspaces.data.items.some((item) => item.id === id) ? children : null}
    </RequireAuth>
  )
}
